import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { WizardPage } from '../../../../general/components/wizard-page';
import { GetStartedVerifyForm } from '../../components/get-started-verify-form';
import { getPromotion } from '../../reducer/promotion';

const GetStartedPageVerify: FC = () => {
  const { search } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const promoCode = params.get('promo');
    if (promoCode) {
      dispatch(getPromotion(promoCode));
    }
  }, [search, dispatch]);

  return (
    <WizardPage
      title="Enter your phone number to begin account verification"
      subtext={<>We need some information to finish verifying your account.</>}
    >
      <GetStartedVerifyForm />
    </WizardPage>
  );
};

export { GetStartedPageVerify };
